import React from 'react';

export default ({ loading }) => <div>{loading && <div>Loading...</div>}</div>;
